const ReviewNote = () => {
    return (
        <div class="card my-4">
            <div class="card-body border-radius-lg p-3" style={{ backgroundColor: "#eaeaea", color: "#4f4f4f"}}>
                {/* <h6 class="mb-0 text-white">
                    Review Before Submitting
                </h6> */}
                <p class="text-sm mb-0 font-weight-bold">
                    Once you submit, you won't be able to edit your documents. Please review all details and ensure everything is correct before completing your application.
                </p>
            </div>
        </div>
    );
};

export default ReviewNote;